import { DetectorActionTypes, AddDetectors, ModifyDetectors, DeleteDetectors } from 'Actions/ActionTypes/index';
import { DetectorConfig, Id } from 'NSwag/ServerClient/Client.nswag';

export const addDetectorConfigs = (detectors: DetectorConfig[]): AddDetectors => ({
    type: DetectorActionTypes.AddDetectors as DetectorActionTypes.AddDetectors,
    detectors
});

export const modifyDetectorConfigs = (detectors: DetectorConfig[]): ModifyDetectors  => ({
    type: DetectorActionTypes.ModifyDetectors as DetectorActionTypes.ModifyDetectors,
    detectors
});

export const deleteDetectorConfigs = (ids: Id[]): DeleteDetectors => ({
    type: DetectorActionTypes.DeleteDetectors as DetectorActionTypes.DeleteDetectors,
    ids
});

export type DetectorAction = ReturnType<typeof addDetectorConfigs | typeof modifyDetectorConfigs | typeof deleteDetectorConfigs>